import React, { useState } from "react";
import "./Gallery.css"; // We'll style with this file

const images = [
  { src: "/imagesevent/event041.jpeg", alt: "Event" },
  { src: "/imagesevent/event042.jpeg", alt: "Event" },
  { src: "/imagesevent/event043.jpeg", alt: "Event" },
  { src: "/imagesevent/event044.jpeg", alt: "Event" },
  { src: "/imagesevent/event045.jpeg", alt: "Event" },
  { src: "/imagesevent/event046.jpeg", alt: "Event" },
  { src: "/imagesevent/event047.jpeg", alt: "Event" },
  { src: "/imagesevent/event048.jpeg", alt: "Event" },
  { src: "/imagesevent/event049.jpeg", alt: "Event" },
  { src: "/imagesevent/event050.jpeg", alt: "Event" },
 
  // Add more images gallery01
];

function Event05() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <>
      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img.src}
            alt={img.alt}
            onClick={() => setSelectedImg(img.src)}
            className="gallery-image"
          />
        ))}
      </div>

      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Zoomed" className="lightbox-image" />
        </div>
      )}
    </>
  );
}

export default Event05;
